import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import CustomTable from "../components/GeneralComponents/CustomTable";
import payments from "../api/payments";
import { cubicMetres, PAGE_SIZE } from "../constants";

const formatDate = (date) => moment(date).format("MMM DD YYYY, h:mm a");

const cellClasses = "textpw-dark font-medium text-[17px]";

const columns = (navigate) => [
  {
    name: "Date",
    selector: (row) => (
      <span className={cellClasses}>{formatDate(row.timestamp)}</span>
    ),
  },
  {
    name: "Amount",
    selector: (row) => (
      <NumericFormat
        thousandSeparator
        decimalScale={2}
        value={Number(row.amount)}
        className={cellClasses}
        displayType="text"
      />
    ),
  },
  {
    name: "Unit",
    selector: (row) => (
      <span className={cellClasses}>
        <NumericFormat
          thousandSeparator
          decimalScale={2}
          value={Number(row.cubic_metres || 0)}
          className={cellClasses}
          displayType="text"
        />{" "}
        {cubicMetres}
      </span>
    ),
  },
  {
    name: "Meter Number",
    selector: (row) => (
      <span className={cellClasses}>{row?.meter?.number}</span>
    ),
  },
  {
    name: " ",
    selector: (row) => (
      <button
        onClick={() => navigate(`/transactions/${row.reference}/receipt`)}
        type="button"
        className="text-pw-blue font-bold text-[17px]"
      >
        View Receipt
      </button>
    ),
  },
];

function Transactions() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const fetchTransactions = async (page) => {
    setLoading(true);
    try {
      const { data } = await payments.getPurchases();
      setData(data.data.results);
      setTotalRows(data.data.count);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    fetchTransactions(page);
  };

  const displayedData = useMemo(() => {
    if (q?.trim()?.length > 0) {
      const query = q.toLowerCase();
      return data.filter(
        (txn) =>
          txn?.amount?.includes(query) ||
          txn?.reference?.toLowerCase().includes(query) ||
          `${Number(txn?.cubic_metres || 0) * 1000}`.includes(query) ||
          formatDate(txn?.timestamp)?.toLowerCase()?.includes(query) ||
          txn?.meter?.number?.includes(query)
      );
    }
    return data;
  }, [data, q]);

  useEffect(() => {
    fetchTransactions(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="pt-10 w-full min-h-screen">
      <div className="w-full">
        <CustomTable
          searchBar
          searchValue={q}
          setSearchValue={setQ}
          columns={columns(navigate)}
          data={displayedData}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          title="Your Purchases"
          paginationPerPage={PAGE_SIZE}
        />
      </div>
    </div>
  );
}

export default Transactions;
